import React from 'react'
import styled from 'styled-components'
import { devices } from 'Utils/devices'

const IconContainer = styled.div`
  justify-content: center;
  align-items: center;
  display: flex;
  height:  75px;  
`
const SVG = styled.svg`
  ${({isFromWidgetChoice}) => isFromWidgetChoice && `
    @media ${devices.tablet} {
      width: 90px; 
      height: 55px;
    }`
  }
`

const EvolutionIcon = ({
  isFromWidgetChoice
}) => (
  <IconContainer>
    <SVG xmlns="http://www.w3.org/2000/svg" isFromWidgetChoice={isFromWidgetChoice} width="96" height="59" viewBox="0 0 96 59">
      <g id="Groupe_3885" data-name="Groupe 3885" transform="translate(-851 -470)">
        <g id="Rectangle_3355" data-name="Rectangle 3355" transform="translate(851 470)" fill="none" stroke="currentColor" strokeWidth="2">
          <rect width="96" height="59" rx="5" stroke="none"/>
          <rect x="1" y="1" width="94" height="57" rx="4" fill="none"/>
        </g>
        <path id="Icon_awesome-arrow-down" data-name="Icon awesome-arrow-down" d="M11.9,7.63l.627.627a.675.675,0,0,1,0,.957l-5.488,5.49a.675.675,0,0,1-.957,0L.6,9.215a.675.675,0,0,1,0-.957l.627-.627a.679.679,0,0,1,.969.011l3.242,3.4V2.928a.676.676,0,0,1,.678-.678h.9a.676.676,0,0,1,.678.678v8.117l3.242-3.4A.674.674,0,0,1,11.9,7.63Z" transform="matrix(-0.875, 0.485, -0.485, -0.875, 890.574, 503.843)" fill="currentColor"/>
        <text id="_1234" data-name="1234" transform="translate(904 505)" fill="currentColor" fontSize="12" fontFamily="Roboto-Thin, Roboto" fontWeight="200"><tspan x="-13.137" y="0">1234</tspan></text>
      </g>
    </SVG>
  </IconContainer>
)

export default EvolutionIcon